import { getField, updateField } from 'vuex-map-fields';
import NotificationService from '../../services/NotificationService';
import Notification from '../../models/Notification';

export default {
    state: {
        notifications: [],
        unreadNotificationCount: null,
        currentPage: null,
        lastPage: null,
        toNotificationsCount: null,
        totalNotificationsCount: null,
        openedNotification: null,
    },

    getters: {
        getField,

        notifications: state => state.notifications
            .map(notification => new Notification(notification)),

        notification: state => state.openedNotification,

        unreadNotificationCount: state => state.unreadNotificationCount,

        currentPage: state => state.currentPage,

        lastPage: state => state.lastPage,
    },

    actions: {
        resetNotifications({ commit }) {
            commit('resetNotifications');
        },
        async loadUnreadNotificationCount({ commit }) {
            await NotificationService.getUnreadNotificationCount().then((count) => {
                return commit('updateNotificationsCount', count);
            });
        },
        async loadNotifications({ commit }, page = 1) {
            await NotificationService.getNotifications(page)
                .then(notificationsData => commit('notifications', notificationsData));
        },
        async openNotification({ commit }, notificationId) {
            await NotificationService.getNotification(notificationId)
                .then(notification => commit('openNotification', notification));
        },
        closeNotification({ commit }, notificationId) {
            commit('closeNotification', notificationId);
        },
        async deleteNotification({ commit }, notificationId) {
            await NotificationService.deleteNotification(notificationId);
        },
    },

    mutations: {
        updateField,
        updateNotificationsCount(state, count) {
            state.unreadNotificationCount = count;
        },
        notifications(state, notificationsData) {
            const notifications = [...state.notifications];
            notifications.push(...notificationsData.data);
            state.notifications = notifications;
            state.currentPage = notificationsData.meta.current_page;
            state.lastPage = notificationsData.meta.last_page;
        },
        openNotification(state, notification) {
            state.openedNotification = notification;
        },
        closeNotification(state) {
            state.openedNotification = null;
        },
        resetNotifications(state) {
            state.notifications = [];
            state.currentPage = null;
            state.lastPage = null;
        },
    },
};
